export const EN_US_TRANSLATIONS = {
  text: {
    therapist: "therapist",
    mindfulness_coach: "mindfulness coach",
    provider: "provider",
    psychiatrist: "psychiatrist",
    faculty: "faculty",
    student: "student",
    resident: "resident",
    zip: "zip / postcode",
    state: "state",
    max_length: '10',
    user: {
      ethnicity: {
        "Black or African American": "Black or African American",
        "Asian American": "Asian American",
        "Indigenous American": "Indigenous American",
        "West Indian Caribbean": "West Indian Caribbean"
      }
    }
  },
  datetimeFormats: {
    numeric: {
      year: "numeric",
      month: "numeric",
      day: "numeric"
    },
    short: {
      year: "numeric",
      month: "short",
      day: "numeric"
    },
    long: {
      year: "numeric",
      month: "short",
      day: "numeric",
      weekday: "short",
      hour: "numeric",
      minute: "numeric"
    }
  }
};
